// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */:host{display:block;width:100%}.input-wrapper{display:block;width:100%}.cell-input{display:block;width:100%;height:26px;margin-top:3px;padding:6px 0 3px;line-height:18px;background:rgba(0,0,0,0);font-weight:inherit}.cell-input:focus{border-bottom-width:2px}.cell-input ::ng-deep .mat-mdc-select-trigger{width:100%}`, "",{"version":3,"sources":["webpack://./packages/core-ui-grid/cell-components/editors/grid-input-cell-editor/grid-select-cell-editor.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAQA,MACE,aAAA,CACA,UAAA,CAGF,eACE,aAAA,CACA,UAAA,CAGF,YACE,aAAA,CACA,UAAA,CACA,WAAA,CACA,cAAA,CACA,iBAAA,CACA,gBAAA,CAEA,wBAAA,CAEA,mBAAA,CAEA,kBACE,uBAAA,CAGF,8CACE,UAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n:host {\n  display: block;\n  width: 100%;\n}\n\n.input-wrapper {\n  display: block;\n  width: 100%;\n}\n\n.cell-input {\n  display: block;\n  width: 100%;\n  height: 26px;\n  margin-top: 3px;\n  padding: 6px 0 3px;\n  line-height: 18px;\n\n  background: transparent;\n\n  font-weight: inherit;\n\n  &:focus {\n    border-bottom-width: 2px;\n  }\n\n  ::ng-deep .mat-mdc-select-trigger {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
